import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import IconButton from "@mui/material/IconButton";
import "./DataEstateTabbedCard.scss";
import CategoryRadarChart from "./DataEstateCards/CategoryRadarChart";
import DataEstateRegulatedCard from "./DataEstateCards/DataEstateRegulatedCard";
import DataEstateSensitiveCard from "./DataEstateCards/DataEsateSensitiveCard";
import CardWrapper, { FilterIcon } from "./CardWrapper";

const TABS = [
  { id: "regulated", label: "Regulated" },
  { id: "category", label: "Category" },
  { id: "sensitivity", label: "Sensitivity" },
];

/**
 * One card with three tabs: Regulated | Sensitivity | Category (spider graph).
 * All three read from /dataEstate/overview (fetched once in DataEstate.jsx).
 */
export default function DataEstateTabbedCard() {
  const [tab, setTab] = useState("regulated");
  const [showFilters, setShowFilters] = useState(false);

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id,
  );
  const overview = useSelector(
    (state) => state.dataTagReducer.dataEstateOverview,
  );

  const overviewLoaded = !!overview?.card3;
  const hasRegulated = (overview?.card3?.regulations || []).length > 0;

  // when a data source has no regulated data, open on Sensitivity (decided once its overview has loaded)
  useEffect(() => {
    if (!overviewLoaded) return;
    setTab(hasRegulated ? "regulated" : "sensitivity");
    setShowFilters(false);
  }, [dataSourceId, overviewLoaded, hasRegulated]);

  const tabs = (
    <div className="de-tabs" role="tablist" aria-label="Data estate views">
      {TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={tab === t.id}
          className={`de-tab ${tab === t.id ? "active" : ""}`}
          onClick={() => setTab(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );

  const actions =
    tab === "regulated" ? (
      <div className="de-regulated-actions">
        <IconButton
          size="small"
          onClick={() => setShowFilters((prev) => !prev)}
          aria-label="Toggle classification filters"
          title="Regulation filters"
        >
          <FilterIcon />
        </IconButton>

        <Popup
          modal
          className="de-popup"
          trigger={<span className="de-expand-icon">⤢</span>}
        >
          {(close) => (
            <div className="parent-popup">
              <div className="de-popup-content">
                <span className="de-popup-close" onClick={close}>
                  ✕
                </span>
                <DataEstateRegulatedCard expanded />
              </div>
            </div>
          )}
        </Popup>
      </div>
    ) : null;

  return (
    <CardWrapper
      title={
        <div className="de-header-row">
          {tabs}
          {actions}
        </div>
      }
    >
      {tab === "regulated" && <DataEstateRegulatedCard showFilters={showFilters} />}
      {tab === "category" && <CategoryRadarChart />}
      {tab === "sensitivity" && <DataEstateSensitiveCard />}
    </CardWrapper>
  );
}